const NODE_ENV = process.env.NODE_ENV;
export const publicIp =
  NODE_ENV === "development" ? "http://localhost:8080" : "";
export const logoImgIp = NODE_ENV === "development" ? "" : "";
export const LOGIN = "/login";
